import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { useEffect,useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import PureCounter from "@srexi/purecounterjs";
function App() {
   const [menuOpen, setMenuOpen] = useState(false);

  const handleToggleClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNav = (e, sectionId, path) => {
    e.preventDefault();
    setMenuOpen(false); // Close menu on nav item click

    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }

    window.history.pushState(null, "", path);
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    new PureCounter();

    const bars = document.querySelectorAll(".progress-bar");
    bars.forEach((bar) => {
      const value = bar.getAttribute("aria-valuenow");
      if (value) bar.style.width = value + "%";
    });

    const onPopState = () => {
      const section = window.location.pathname.replace("/", "") || "hero";
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return (
    <div>
      <header
        id="header"
        className={`header d-flex flex-column justify-content-center ${
          menuOpen ? "header-show" : ""
        }`}
      >
        <i
          className={`header-toggle d-xl-none bi ${menuOpen ? "bi-x" : "bi-list"}`}
          onClick={handleToggleClick}
          style={{ cursor: "pointer" }}
        ></i>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li>
              <a
                href="/"
                onClick={(e) => handleNav(e, "hero", "/")}
                className={window.location.pathname === "/" ? "active" : ""}
              >
                <i className="bi bi-house navicon"></i>
                <span>Home</span>
              </a>
            </li>
            <li>
              <a
                href="/about"
                onClick={(e) => handleNav(e, "about", "/about")}
                className={window.location.pathname === "/about" ? "active" : ""}
              >
                <i className="bi bi-person navicon"></i>
                <span>About</span>
              </a>
            </li>
            <li>
              <a
                href="/resume"
                onClick={(e) => handleNav(e, "resume", "/resume")}
                className={window.location.pathname === "/resume" ? "active" : ""}
              >
                <i className="bi bi-file-earmark-text navicon"></i>
                <span>Resume</span>
              </a>
            </li>
            <li>
              <a
                href="/portfolio"
                onClick={(e) => handleNav(e, "portfolio", "/portfolio")}
                className={window.location.pathname === "/portfolio" ? "active" : ""}
              >
                <i className="bi bi-images navicon"></i>
                <span>Portfolio</span>
              </a>
            </li>
            <li>
              <a
                href="/services"
                onClick={(e) => handleNav(e, "services", "/services")}
                className={window.location.pathname === "/services" ? "active" : ""}
              >
                <i className="bi bi-hdd-stack navicon"></i>
                <span>Services</span>
              </a>
            </li>
            <li>
              <a
                href="/contact"
                onClick={(e) => handleNav(e, "contact", "/contact")}
                className={window.location.pathname === "/contact" ? "active" : ""}
              >
                <i className="bi bi-envelope navicon"></i>
                <span>Contact</span>
              </a>
            </li>
          </ul>
        </nav>
      </header>
      <main className="main">
        <section id="hero" className="hero section light-background">
          <img src="./img/hero-bg.jpg" alt="" />

          <div className="container" data-aos="zoom-out">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <h2>Priyanka Kumavat</h2>
                <p>
                  I'm{" "}
                  <span
                    className="typed"
                    data-typed-items="Designer, Developer, Freelancer, Photographer"
                  >
                    Software Engineer
                  </span>
                  <span
                    className="typed-cursor typed-cursor--blink"
                    aria-hidden="true"
                  ></span>
                </p>
                {/* <div className="social-links">
                  <a href="#">
                    <i className="bi bi-twitter-x"></i>
                  </a>
                  <a href="#">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="#">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        <section id="about" className="about section">
          <div className="container section-title" data-aos="fade-up">
            <h2>About Me</h2>
            <p>
              I'm Priyanka Kumavat, a Full Stack Web Developer with 3+ years of
              experience in Angular, React.js, Node.js, and MongoDB. I build
              clean, responsive, and scalable web applications tailored to
              client needs. From business websites to admin panels and APIs, I
              deliver quality solutions with clear communication and on-time
              delivery.
            </p>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row justify-content-center">
              <div className="col-lg-10 content">
                <h2 className="text-center">Full Stack Web Developer</h2>
                <p className="fst-italic py-3 text-center">
                  I’m Priyanka Kumavat, a Full Stack Web Developer with 4+ years
                  of experience in Angular, React.js, Node.js, PHP, and Shopify.
                  I build responsive, user-friendly applications with a strong
                  backend using Express.js, MySQL, and MongoDB—delivering clean
                  code and seamless UI/UX for modern business solutions.
                </p>
                <div className="row">
                  <div className="col-lg-6">
                    <ul>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>Website:</strong>
                        <span>www.priyankakumavat.dev</span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>Phone:</strong>
                        <span>+91 8308655001</span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>City:</strong>
                        <span>Nashik, India</span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <ul>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>Degree:</strong>
                        <span>Bachelor in Information Technology</span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>Email:</strong>
                        <span>priyankakumavat10@gmail.com</span>
                      </li>
                      <li>
                        <i className="bi bi-chevron-right"></i>
                        <strong>Freelance:</strong>
                        <span>Available</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="py-3">
                  I’ve worked across diverse industries like education,
                  healthcare, hospitality, and e-commerce — delivering
                  end-to-end solutions including custom websites, full-stack
                  applications, ERP systems, and Shopify stores.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="stats" className="stats section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4">
              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-emoji-smile"></i>
                <div className="stats-item">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="6"
                    data-purecounter-duration="1"
                    className="purecounter"
                  ></span>
                  <p>Happy Clients</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-journal-richtext"></i>
                <div className="stats-item">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="12"
                    data-purecounter-duration="1"
                    className="purecounter"
                  ></span>
                  <p>Projects Completed</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-headset"></i>
                <div className="stats-item">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="1500"
                    data-purecounter-duration="1"
                    className="purecounter"
                  ></span>
                  <p>Hours of Development</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-laptop"></i>
                <div className="stats-item">
                  <span
                    data-purecounter-start="0"
                    data-purecounter-end="4"
                    data-purecounter-duration="1"
                    className="purecounter"
                  ></span>
                  <p>Years of Experience</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="skills" className="skills section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Skills</h2>
            <p>
              Skilled in both frontend and backend technologies, I specialize in
              full-stack development with a strong focus on clean UI,
              performance, and scalability.
            </p>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row skills-content skills-animation">
              <div className="col-lg-6">
                <div className="progress">
                  <span className="skill">
                    <span>HTML5</span> <i className="val">100%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>CSS3 / SCSS</span> <i className="val">95%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="95"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>JavaScript / TypeScript</span>{" "}
                    <i className="val">85%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="85"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>Angular</span> <i className="val">90%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="90"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="progress">
                  <span className="skill">
                    <span>React.js</span> <i className="val">85%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="85"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>Node.js / Express.js</span> <i className="val">80%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="80"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>MongoDB / MySQL</span> <i className="val">75%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="75"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <div className="progress">
                  <span className="skill">
                    <span>PHP / Shopify</span> <i className="val">70%</i>
                  </span>
                  <div className="progress-bar-wrap">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow="70"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="resume" className="resume section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Resume</h2>
            <p>
              Explore my professional experience and educational qualifications.
            </p>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            {/* Tabs */}
            <ul
              className="nav nav-tabs justify-content-center mb-4"
              id="resumeTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="experience-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#experience"
                  type="button"
                  role="tab"
                  aria-controls="experience"
                  aria-selected="true"
                >
                  Experience
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="education-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#education"
                  type="button"
                  role="tab"
                  aria-controls="education"
                  aria-selected="false"
                >
                  Education
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="resumeTabContent">
              {/* Experience Timeline */}
              <div
                className="tab-pane fade show active"
                id="experience"
                role="tabpanel"
                aria-labelledby="experience-tab"
              >
                <div className="timeline">
                  {/* Items alternate left and right */}
                  <div className="timeline-item left">
                    <h4>Freelance Full Stack Developer</h4>
                    <h5>June 2024 – Present</h5>
                    <p>
                      <em>Remote</em>
                    </p>
                    <ul>
                      <li style={{ textAlign: "justify" }}>
                        Built restaurant and education web apps using React,
                        Angular, and MySQL.
                      </li>
                      <li style={{ textAlign: "justify" }}>
                        Handled frontend/backend integration and admin panels.
                      </li>
                    </ul>
                  </div>

                  <div className="timeline-item right">
                    <h4>Software Developer – Maxdigi Solutions</h4>
                    <h5>Sept 2023 – May 2024</h5>
                    <p>
                      <em>Nashik, India</em>
                    </p>
                    <ul>
                      <li>
                        Developed Angular/React projects with Node.js and
                        PostgreSQL.
                      </li>
                      <li>Worked on dashboards, CMS, and API integration.</li>
                    </ul>
                  </div>

                  <div className="timeline-item left">
                    <h4>Software Developer – Sumago Infotech</h4>
                    <h5>July 2021 – Jan 2023</h5>
                    <p>
                      <em>Nashik, India</em>
                    </p>
                    <ul>
                      <li style={{ textAlign: "justify" }}>
                        Built full-stack apps using Angular, React, Node.js, and
                        MongoDB.
                      </li>
                      <li style={{ textAlign: "justify" }}>
                        Mentored 30+ students in Angular and live project
                        development.
                      </li>
                    </ul>
                  </div>

                  <div className="timeline-item right">
                    <h4>Jr. Software Developer – HOH Tech Labs</h4>
                    <h5>Feb 2020 – Sept 2020</h5>
                    <p>
                      <em>Nashik, India</em>
                    </p>
                    <ul>
                      <li>
                        Worked with Angular, Node.js, Express, and MongoDB.
                      </li>
                      <li>
                        Learned core full stack practices and real project flow.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Education Timeline */}
              <div
                className="tab-pane fade"
                id="education"
                role="tabpanel"
                aria-labelledby="education-tab"
              >
                <div className="timeline">
                  <div className="timeline-item left">
                    <h4>B.E. in Information Technology</h4>
                    <h5>2016 – 2019</h5>
                    <p>
                      <em>MET's Institute of Engineering, Nashik</em>
                    </p>
                  </div>

                  <div className="timeline-item right">
                    <h4>Diploma in Information Technology</h4>
                    <h5>2013 – 2016</h5>
                    <p>
                      <em>SMES Polytechnic, Nashik</em>
                    </p>
                  </div>

                  <div className="timeline-item left">
                    <h4>SSC - Secondary School Certificate</h4>
                    <h5>2012 – 2013</h5>
                    <p>
                      <em>Shree Chhatrapati Shivaji Vidhyalay, Nashik</em>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="portfolio" className="portfolio section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Portfolio</h2>
            <p>
              Explore some of the key projects I’ve worked on over the past 4
              years—ranging from education platforms to hospital systems and CMS
              dashboards.
            </p>
          </div>

          <div className="container">
            <div className="row gy-4" data-aos="fade-up" data-aos-delay="200">
              {/* Maxdigi Education - Angular Project */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img
                  src="/img/port3.png"
                  className="img-fluid"
                  alt="Maxdigi Education"
                />
                <div className="portfolio-info">
                  <h4>Maxdigi Education</h4>
                  <p>Angular + Admin Panel CMS</p>
                  <a
                    href="/img/port3.png"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="Maxdigi Education"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a href="/" title="Project Link" className="details-link">
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>

              {/* Astro Sports - Angular + Animation */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img
                  src="/img/port1.png"
                  className="img-fluid"
                  alt="Astro Sports"
                />
                <div className="portfolio-info">
                  <h4>Astro Sports</h4>
                  <p>Angular 15 with Animation</p>
                  <a
                    href="/img/port1.png"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="Astro Sports"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a
                    href="https://www.astrosports.in/"
                    title="Project Link"
                    className="details-link"
                    target="_blank"
                  >
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>

              {/* Javix – Hospital Management System */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img
                  src="/img/port5.png"
                  className="img-fluid"
                  alt="Javix HMS"
                />
                <div className="portfolio-info">
                  <h4>Javix</h4>
                  <p>React.js + Node.js + MongoDB</p>
                  <a
                    href="/img/projects/javix-hms.jpg"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="Javix Hospital Management System"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a href="/" title="Project Link" className="details-link">
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>

              {/* Swastik Wellbeing - React Frontend */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img
                  src="/img/port2.png"
                  className="img-fluid"
                  alt="Swastik Wellbeing"
                />
                <div className="portfolio-info">
                  <h4>Swastik Wellbeing</h4>
                  <p>React.js + TypeScript + API Integration</p>
                  <a
                    href="/img/port2.png"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="Swastik Wellbeing"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a
                    href="https://swastikwellbeing.com/"
                    title="Project Link"
                    className="details-link"
                    target="_blank"
                  >
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>

              {/* MSINS */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img src="/img/port4.png" className="img-fluid" alt="Msins" />
                <div className="portfolio-info">
                  <h4>MSINS</h4>
                  <p>React JS + Node.js + MongoDB</p>
                  <a
                    href="/img/port4.png"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="msins"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a
                    href="https://msins.in/"
                    target="_blank"
                    title="Project Link"
                    className="details-link"
                  >
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>

              {/* Soil charger Technology */}
              <div className="col-lg-4 col-md-6 portfolio-item">
                <img src="/img/port6.jpeg" className="img-fluid" alt="soil" />
                <div className="portfolio-info">
                  <h4>Soil Charger Technoloogy</h4>
                  <p>Angular + PHP + Mysql</p>
                  <a
                    href="/img/port6.jpeg"
                    data-gallery="portfolio-gallery"
                    className="glightbox preview-link"
                    title="Soil"
                    target="_blank"
                  >
                    <i className="bi bi-zoom-in"></i>
                  </a>
                  <a href="/" title="Project Link" className="details-link">
                    <i className="bi bi-link-45deg"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" className="services section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Services</h2>
            <p>
              I help startups, businesses, and individuals build fast, scalable,
              and modern web applications using the latest full stack
              technologies. Here’s what I can offer to bring your ideas to life.
            </p>
          </div>

          <div className="container">
            <div className="row gy-4">
              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="service-item item-cyan position-relative">
                  <div className="icon">
                    <i className="bi bi-globe"></i>
                  </div>
                  <h3>Custom Website Development</h3>
                  <p>
                    Responsive and SEO-friendly websites built with HTML, CSS,
                    JavaScript, Angular, or React for businesses, portfolios,
                    and institutions.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="service-item item-orange position-relative">
                  <div className="icon">
                    <i className="bi bi-ui-checks-grid"></i>
                  </div>
                  <h3>Admin Panel & Dashboard</h3>
                  <p>
                    Custom CMS, dashboard, and admin panels using Angular or
                    React integrated with Node.js, MongoDB, or MySQL.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="service-item item-teal position-relative">
                  <div className="icon">
                    <i className="bi bi-diagram-3"></i>
                  </div>
                  <h3>API Development & Integration</h3>
                  <p>
                    RESTful API development and third-party integration using
                    Node.js and Express for secure and scalable backends.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="service-item item-red position-relative">
                  <div className="icon">
                    <i className="bi bi-shop-window"></i>
                  </div>
                  <h3>eCommerce Solutions</h3>
                  <p>
                    Shopify store setup, product management, custom themes, and
                    integration with payment gateways or backend APIs.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="500"
              >
                <div className="service-item item-indigo position-relative">
                  <div className="icon">
                    <i className="bi bi-phone"></i>
                  </div>
                  <h3>Mobile-Friendly UI/UX Design</h3>
                  <p>
                    Pixel-perfect, responsive, and accessible designs built with
                    Bootstrap, SCSS, and modern CSS techniques.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay="600"
              >
                <div className="service-item item-pink position-relative">
                  <div className="icon">
                    <i className="bi bi-tools"></i>
                  </div>
                  <h3>Maintenance & Support</h3>
                  <p>
                    Bug fixes, performance optimization, feature updates, and
                    ongoing technical support to keep your project running
                    smoothly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="contact section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Contact</h2>
            <p>
              Feel free to reach out for freelance opportunities,
              collaborations, or any software development queries.
            </p>
          </div>

          <div className="container" data-aos="fade" data-aos-delay="100">
            <div className="row gy-4">
              <div className="col-lg-4">
                <div
                  className="info-item d-flex flex-column align-items-center text-center shadow-sm p-4 rounded"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{ background: "#fff", borderRadius: "10px" }}
                >
                  <i className="bi bi-geo-alt flex-shrink-0 mb-3 fs-3 text-primary"></i>
                  <div>
                    <h3>Address</h3>
                    <p>Nashik, Maharashtra, India – 422010</p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <a href="tel:+918308655001" style={{ textDecoration: "none" }}>
                  <div
                    className="info-item d-flex flex-column align-items-center text-center shadow-sm p-4 rounded"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    style={{
                      background: "#fff",
                      borderRadius: "10px",
                      color: "#000",
                    }}
                  >
                    <i className="bi bi-telephone flex-shrink-0 mb-3 fs-3 text-primary"></i>
                    <div>
                      <h3>Call Me</h3>
                      <p>+91 8308655001</p>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4">
                <a
                  href="mailto:priyankakumavat10@gmail.com"
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="info-item d-flex flex-column align-items-center text-center shadow-sm p-4 rounded"
                    data-aos="fade-up"
                    data-aos-delay="400"
                    style={{
                      background: "#fff",
                      borderRadius: "10px",
                      color: "#000",
                    }}
                  >
                    <i className="bi bi-envelope flex-shrink-0 mb-3 fs-3 text-primary"></i>
                    <div>
                      <h3>Email Me</h3>
                      <p>priyankakumavat10@gmail.com</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer id="footer" className="footer position-relative light-background">
        <div className="container text-center">
          <h3 className="sitename">Priyanka Kumavat</h3>
          <p>
            Full Stack Web Developer skilled in Angular, React, Node.js, and
            PHP. Let's connect and build something great together.
          </p>

          <div className="social-links d-flex justify-content-center gap-3 mt-3">
            <a
              href="https://www.linkedin.com/in/priyanka-kumavat-40a469148"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-linkedin fs-4"></i>
            </a>
            <a
              href="https://github.com/priyankak31/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-github fs-4"></i>
            </a>
          </div>

          <div className="copyright mt-4">
            &copy; {new Date().getFullYear()}{" "}
            <strong className="px-1 sitename">Priyanka Kumavat</strong> | All
            Rights Reserved
          </div>
        </div>
      </footer>

      <a
        href="#"
        id="scroll-top"
        className="scroll-top d-flex align-items-center justify-content-center"
      >
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </div>
  );
}

export default App;
